import '../../assets/index17.css';var p = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var l = (o, e, r) => e in o ? p(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    d.call(e, r) && l(o, r, e[r]);
  if (t)
    for (var r of t(e))
      s.call(e, r) && l(o, r, e[r]);
  return o;
};
var _ = (o, e) => {
  var r = {};
  for (var i in o)
    d.call(o, i) && e.indexOf(i) < 0 && (r[i] = o[i]);
  if (o != null && t)
    for (var i of t(o))
      e.indexOf(i) < 0 && s.call(o, i) && (r[i] = o[i]);
  return r;
};
import { jsx as v } from "react/jsx-runtime";
import { forwardRef as D } from "react";
import { D as f } from "../../Divider-CB6EOLnF.js";
const u = "Divider-module__root___yqvae", b = "Divider-module__label___ytI50", y = {
  root: u,
  label: b
}, x = D((N, n) => {
  var a = N, {
    "data-plum-id": o,
    orientation: e = "horizontal",
    variant: r = "solid",
    labelPosition: i = "center"
  } = a, c = _(a, [
    "data-plum-id",
    "orientation",
    "variant",
    "labelPosition"
  ]);
  return /* @__PURE__ */ v(
    f,
    m({
      ref: n,
      orientation: e,
      variant: r,
      labelPosition: i,
      classNames: y,
      "data-plum-id": o
    }, c)
  );
});
x.displayName = "Divider";
export {
  x as Divider
};
